import { createStore } from 'vuex'
// import i18n from '@/i18n'
// import i18next from 'i18next'

export default createStore({
  state: {
    lang: localStorage.getItem('lang') || 'ko',
    pageNum: 0,
    user_ip: '',
    nowPath: '/',
    activeSubIdx: 0
  },
  getters: {
    getLang: (state) => state.lang,
    getPageNum: (state) => state.pageNum,
    getUserIp: (state) => state.user_ip,
    getNowPath: (state) => state.nowPath,
    getActiveIdx: (state) => state.activeSubIdx
  },
  mutations: {
    setLang (state, payload) {
      state.lang = payload
      if (state.lang === 'kr') state.lang = 'ko'
      if (state.lang === 'en') state.lang = 'en'
      if (state.lang === 'jp') state.lang = 'ja'
      else if (state.lang !== 'en' && state.lang !== 'ko' && state.lang !== 'ja') state.lang = 'en'
      localStorage.setItem('lang', state.lang)
    },
    plusPageNum (state) {
      return state.pageNum++
    },
    minusPageNum (state) {
      return state.pageNum--
    },
    setPageNum (state, payload) {
      state.pageNum = payload
    },
    setUserIp (state, payload) {
      state.user_ip = payload
    },
    setNowPath (state, payload) {
      state.nowPath = payload
    },
    setActiveIdx (state, payload) {
      state.activeSubIdx = payload
    }
  },
  actions: {
    setLang ({ commit }, payload) {
      commit('setLang', payload)
    },
    getLang ({ commit }, payload) {
      const lang = (localStorage.getItem('lang'))
      if (lang) {
        commit('setLang', lang)
      } else {
        commit('setLang', payload)
      }
    },
    getIp ({ commit, dispatch }, res) {
      const country = JSON.parse(res.data.replace('geoip(', '').replace(')', ''))
      if (country.country_code === 'KR') {
        commit('setUserIp', 'ko')
        dispatch('getLang', 'ko')
        localStorage.setItem('user_ip', 'ko')
      } else if (country.country_code === 'JP') {
        commit('setUserIp', 'ja')
        dispatch('getLang', 'ja')
        localStorage.setItem('user_ip', 'ja')
      } else {
        commit('setUserIp', 'en')
        dispatch('getLang', 'en')
        localStorage.setItem('user_ip', 'en')
      }
    }
  }
})
